import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/config/doctorConfig";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { TrustCards } from "@/components/TrustCards";
import { About } from "@/components/About";
import { Expertise } from "@/components/Expertise";
import { Publications } from "@/components/Publications";
import { Conditions } from "@/components/Conditions";
import { WhyConsult } from "@/components/WhyConsult";
import { Appointment } from "@/components/Appointment";
import { Location } from "@/components/Location";
import { Resources } from "@/components/Resources";
import { BlogSection } from "@/components/BlogSection";
import { Faq } from "@/components/Faq";
import { Reviews } from "@/components/Reviews";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:url" content={`${SITE_URL}/`} />
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <TrustCards />
        <About />
        <Expertise />
        <Publications />
        <Conditions />
        <WhyConsult />
        <Appointment />
        <Location />
        <Resources />
        <BlogSection />
        <Faq />
        <Reviews />
      </main>
      <Footer />
      <MobileActionBar />
    </>
  );
}
